import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppState } from '../../ngxs/app/app.state';
import { WorkNews } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-news-item',
  templateUrl: './ax-news-item.component.html',
  styleUrls: ['./ax-news-item.component.scss'],
})
export class AxNewsItemComponent implements OnInit {
  @Input() newsItem: WorkNews;
  @Output() openNewsDetail: EventEmitter<WorkNews> = new EventEmitter<WorkNews>();
  public isEmployee = false;

  constructor(private readonly store: Store) {
  }

  ngOnInit() {
    this.store.select(AppState.profile).subscribe(profile => this.isEmployee = profile.isUserEntity);
  }
}
